module.exports = __webpack_public_path__ + "img/img3.a6acf6f8.png";